export const YYYY_MM_DD = "YYYY-MM-DD";
export const YYYY_MM_DD_HH_mm_ss = "YYYY-MM-DD HH:mm:ss";
export const YYYY_MM_DD_T_HH_mm_ss = "YYYY-MM-DDTHH:mm:ss";
